module.exports = __webpack_public_path__ + "static/4_2_recommendation_PT-65ea1ff37df5fd029f418e24cbdb6fa3.svg";